import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@/icons';
import { Modal } from './Modal';
import { useTheme } from '../contexts/ThemeContext';

export interface AutoSavingModalProps {
    isOpen: boolean;
}

/**
 * Non-dismissible "Saving..." indicator shown while a same-user save collision is being
 * silently resolved via an unconditional force save (see SimpleCaseContext/Provider.tsx's
 * autoForceSave and docs/AUTOSAVE_DETAILS.md §18). There is nothing for the user to decide here
 * -- the conflicting version was their own other tab/device -- so no buttons, no close action.
 * A 15s failsafe in Provider.tsx closes this and falls back to SaveConflictModal if the save
 * hasn't finished by then.
 */
export const AutoSavingModal: React.FC<AutoSavingModalProps> = ({ isOpen }) => {
    const theme = useTheme();

    if (!isOpen) {
        return null;
    }

    return (
        <Modal isOpen={isOpen} onClose={() => {}} title="Saving..." showCloseButton={false}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing.sm,
                color: theme.colors.text.primary,
            }}>
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>Saving your changes...</span>
            </div>
        </Modal>
    );
};
